"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlsJSDriver = void 0;
const tslib_1 = require("tslib");
const state_flow_1 = require("@video/state-flow");
const hls_js_1 = tslib_1.__importDefault(require("hls.js"));
const errors_deprecated_1 = require("../../../../internal/errors-deprecated");
const bind_1 = require("../../../../internal/utils/bind");
const Audio = tslib_1.__importStar(require("../../state-flow/controls/audio"));
const Playback = tslib_1.__importStar(require("../../state-flow/controls/playback"));
const HlsJS = tslib_1.__importStar(require("../../state-flow/drivers/hlsjs"));
const encoding_selectors_1 = require("../encoding-selectors");
const helpers_1 = require("../helpers");
const register_1 = require("../register");
const common_1 = require("./common");
// returns wrapper to make sure that we use native hls
function wrap(fn) {
    const wrapper = (ss, sf) => {
        // check if nativeHls driver is in use
        if (!HlsJS.InUse.is(sf.hlsJs)) {
            return state_flow_1.Result.ignore();
        }
        return fn(ss, sf);
    };
    Reflect.defineProperty(wrapper, "name", { configurable: true, value: fn.name });
    return wrapper;
}
class HlsJSDriver {
    // private sf!: PlayerStateFlow;
    constructor(ctx) {
        this.ctx = ctx;
        // readonly debugInfo: unknown;
        this.encodingSelector = new encoding_selectors_1.HighestBitrateSelector();
        // metadata: unknown;
        this.availableEncodings = [];
        (0, bind_1.makeBounded)(this);
        this.hls = new hls_js_1.default();
    }
    //
    // get host(): VideoElement {
    //   if (this.sf.host.element == null) {
    //     throw new Error("host is null");
    //   }
    //   return this.sf.host.element as VideoElement;
    // }
    //
    // get active(): boolean {
    //   return NativeHls.InUse.is(this.sf.nativeHls);
    // }
    static isManifestSupported(manifest) {
        return (manifest === null || manifest === void 0 ? void 0 : manifest.formats["mp4-hls"]) != null;
    }
    static isHostSupported(host) {
        return (0, common_1.isVideoElement)(host);
    }
    static isPlatformSupported() {
        return hls_js_1.default.isSupported();
    }
    initStateFlow(sf) {
        sf.handleEnter(HlsJS.Prepared, this.prepare);
        sf.handleEnter(HlsJS.InUse, this.activate);
        sf.handleExit(HlsJS.InUse, this.deactivate);
        // sf.onCommit(Host.Attached, this.onHostAttached);
        // sf.handleExit(Host.Attached, wrap(this.onHostDetaching));
        sf.handleEnter(Playback.Playing, wrap(common_1.startPlayingVideoElement));
        sf.handleExit(Playback.Playing, wrap(common_1.stopPlayingVideoElement));
        sf.handleEnter(Audio.UnMuted, wrap(common_1.unmuteVideoElement));
        sf.handleChanges(Audio.UnMuted, wrap(common_1.changeVolumeVideoElement));
        sf.handleExit(Audio.UnMuted, wrap(common_1.muteVideoElement));
    }
    prepare(states) {
        return state_flow_1.Result.ok();
    }
    activate({ host, manifest }) {
        const el = (0, common_1.getVideoElement)(host.element);
        if (manifest.json == null) {
            throw Error("manifest is null");
        }
        const format = manifest.json.formats["mp4-hls"];
        const encoding = this.encodingSelector.select((0, helpers_1.parseEncodings)(format));
        if ((encoding === null || encoding === void 0 ? void 0 : encoding.location) == null || encoding.location === "") {
            throw new errors_deprecated_1.DriverNotSupportedError("invalid encoding", {});
        }
        this.hls.attachMedia(el);
        this.hls.loadSource(encoding.location);
        return state_flow_1.Result.ok();
    }
    deactivate({ host }) {
        const el = (0, common_1.getVideoElement)(host.element);
        // some cleanup
        this.hls.stopLoad();
        this.hls.detachMedia();
        el.src = "";
        return state_flow_1.Result.ok();
    }
    async [Symbol.dispose]() {
        this.hls.destroy();
    }
}
exports.HlsJSDriver = HlsJSDriver;
HlsJSDriver.displayName = "HlsJSDriver";
HlsJSDriver.driverName = "hlsjs";
(0, register_1.registerVideoDrivers)(HlsJSDriver);
//# sourceMappingURL=hlsjs.js.map